import { render, staticRenderFns } from "./ForeignPass.vue?vue&type=template&id=26c7fe90&"
import script from "./ForeignPass.vue?vue&type=script&lang=js&"
export * from "./ForeignPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports